import Vue from 'vue'
import App from './App'
import firebase from 'firebase/app'
import colors from 'vuetify/es5/util/colors'
import router from './router'
import { store } from './store'
import DateFilter from './filters/date'
import TemperatureFilter from './filters/temperature'
import VolumeFilter from './filters/volume'
import LowerCase from './filters/lowercase'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Snackbar from '@/components/Base/Snackbar'
import ProgressCircularContainer from '@/components/Base/ProgressCircularContainer'
import VueI18n from 'vue-i18n'
import messages from './i18n'

Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'pt_BR', // set locate
  messages // set locale messages
})

Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken2,
    accent: colors.blue.accent2,
    secondary: colors.grey.lighten1,
    info: colors.blue.lighten1,
    warning: colors.amber.darken2,
    error: colors.red.accent4,
    success: colors.green.lighten2
  }
})

Vue.config.productionTip = false

Vue.filter('date', DateFilter)
Vue.filter('temperature-filter', TemperatureFilter)
Vue.filter('volume-filter', VolumeFilter)
Vue.filter('lower-case-filter', LowerCase)
Vue.component('app-snackbar', Snackbar)
Vue.component('app-progress-circular-container', ProgressCircularContainer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyD9-RHIjF4vkejef3OhkPUHqBLpFFo_d5E',
      authDomain: 'inobram-platform.firebaseapp.com',
      databaseURL: 'https://inobram-platform.firebaseio.com',
      projectId: 'inobram-platform',
      storageBucket: 'inobram-platform.appspot.com',
      messagingSenderId: '882668789300',
      appId: '1:882668789300:web:0817aa0b9370e5ca96b461'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignUserIn', user)
      }
    })
    firebase.database().ref('.info/connected').on('value', (snap) => {
      if (snap.val() === true) {
        this.$store.dispatch('setConnection', true)
      } else {
        this.$store.dispatch('setConnection', false)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js